import React from "react";
import { Button, SelectBox, DateBox } from "devextreme-react";
import { formatMessage } from "devextreme/localization";
import { useScreenSize } from "../../../utils/media-query";
import "./style.scss";

export default function ToolbarDataGrid({
  middleware,
  filter,
  setFilter,
  handleChangeSelectBox,
  user,
  employeeOid,
  setEmployeeOid,
  employee
}) {
  const { isXSmall, isSmall } = useScreenSize();

  function gridBoxDisplayExpr(item) {
    return item && `${item.EmployeeCode} - ${item.FullName}`;
  }

  return (
    <div className="form_select_box_list">
      {middleware?.ReadState && (
        <>
          <span className="name">{formatMessage("From")}: </span>
          <DateBox
            type="date"
            className="mr-1"
            width={isXSmall || isSmall ? null : 120}
            defaultValue={filter.FromDate}
            onValueChanged={(e) => setFilter({ ...filter, FromDate: e.value })}
          />
          <span className="name">{formatMessage("To")}: </span>
          <DateBox
            type="date"
            className="mr-1"
            width={isXSmall || isSmall ? null : 120}
            defaultValue={filter.ToDate}
            onValueChanged={(e) => setFilter({ ...filter, ToDate: e.value })}
          />
          {user.IsDeclarant === "True" && (
            <SelectBox
              valueExpr="Oid"
              dataSource={employee}
              value={employeeOid}
              displayExpr={gridBoxDisplayExpr}
              className="mr-1"
              itemRender={gridBoxDisplayExpr}
              onValueChanged={(e) => {
                setEmployeeOid(e.value);
              }}
              searchEnabled={true}
            />
          )}
          <Button
            icon="revert"
            text={formatMessage("View")}
            onClick={handleChangeSelectBox}
          />
        </>
      )}
    </div>
  );
}
